module.exports = __webpack_public_path__ + "static/media/vivi-mostrandoacima-esquerda.90f474fa.svg";